module.exports = __webpack_public_path__ + "img/people.2937b07f.png";